import { createContext, type ReactNode, useContext, useState } from "react";

interface ChatSidebarContextType {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

const ChatSidebarContext = createContext<ChatSidebarContextType | null>(null);

export function ChatSidebarProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  const toggle = () => setIsOpen((prev) => !prev);

  return (
    <ChatSidebarContext.Provider value={{ isOpen, open, close, toggle }}>
      {children}
    </ChatSidebarContext.Provider>
  );
}

export function useChatSidebar() {
  const context = useContext(ChatSidebarContext);
  return context; // Returns null if not within provider
}

export function useChatSidebarStrict() {
  const context = useContext(ChatSidebarContext);
  if (!context) {
    throw new Error("useChatSidebarStrict must be used within ChatSidebarProvider");
  }
  return context;
}
